
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const DealerRegistrationPage = lazy(() => import('../pages/dealer-registration/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const InspirationPage = lazy(() => import('../pages/inspiration/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/dealer-registration',
    element: <DealerRegistrationPage />
  },
  {
    path: '/category/:slug',
    element: <CategoryPage />
  },
  {
    path: '/product/:id',
    element: <ProductPage />
  },
  {
    path: '/inspiration',
    element: <InspirationPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
